export const getTags = state => state.tags;
export const getServiceOptions = state => state.serviceOptions;
export const getFacilityOptions = state => state.facilityOptions;
export const getParkingOptions = state => state.parkingOptions;
export const getGoodForOptions = state => state.goodForOptions;
export const getMealOptions = state => state.mealOptions;
export const getFoodOptions = state => state.foodOptions;
export const getTagsObject = state => state.tagsObject;
export const getServiceOptionsObject = state => state.serviceOptionsObject;
export const getFacilityOptionsObject = state => state.facilityOptionsObject;
export const getParkingOptionsObject = state => state.parkingOptionsObject;
export const getGoodForOptionsObject = state => state.goodForOptionsObject;
export const getMealOptionsObject = state => state.mealOptionsObject;
export const getFoodOptionsObject = state => state.foodOptionsObject;
